module.exports = {"":{"domain":"sentry","plural_forms":"nplurals=2; plural=(n != 1)","lang":"en"}};